import * as constants from './../constants'

export const getNewRequestedProduct = (selectedItems, item) => {
  const selectedItem = selectedItems.find(i => i.id === item.id) || {}

  if (
    selectedItem.actionType === constants.actionTypes.exchange &&
    selectedItem?.exchangeType === constants.allowedExchangeMethods.otherProductsVariants
  ) {
    return {
      ...selectedItem?.selectedProduct,
      price_currency: item.price_currency,
    }
  }

  if (
    selectedItem.actionType === constants.actionTypes.exchange &&
    selectedItem?.exchangeType === constants.allowedExchangeMethods.variants
  ) {
    const variant = selectedItem?.variants.find(variant => variant.id === selectedItem?.variantId)

    return {
      ...item,
      price: variant?.price || item.price,
      price_currency: item.price_currency,
      variant,
      sku: variant?.sku,
    }
  }

  if (
    selectedItem.actionType === constants.actionTypes.exchange &&
    selectedItem?.exchangeType === constants.allowedExchangeMethods.otherProducts
  ) {
    return {
      exchange_info: selectedItem?.exchangeInfo,
    }
  }
}

export const getExtraProducts = (selectedItems, item) => {
  const extraProducts = selectedItems.find(p => p.id === item.id)?.extraProducts

  return extraProducts?.map(product => {
    return {
      ...product,
      price_currency: item.price_currency,
    }
  })
}
